#import '@/graphql/shopify/product/ProductCardFragment.gql';

query ShopifyCollectionQuery($handle: String!, $limit: Int = 20, $cursor: String = null, $lang: LanguageCode!)
@inContext(language: $lang) {
  collection: collectionByHandle(handle: $handle) {
    handle
    title
    products(first: $limit, after: $cursor) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ...ProductCardFragment
        }
      }
    }
  }
}
